// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Route, Switch } from 'react-router-dom';
import NotFound from './containers/NotFound';
import { Login } from './containers/Login';
import Parties from './containers/Parties';
import Users from './containers/Users';
import Party from './containers/Party';
import User from './containers/User';
import { Event } from './containers/Event';
import Activities from './containers/Activities';
import ActivityPage from './containers/Activity';
import CityExplore from './containers/CityExplore';
import CityGuide from './containers/Cityguide';
import { Entertainments } from './containers/Entertainments';
import Orders from './containers/Orders';
import OrderPage from './containers/Order';
import { Tags } from './containers/Tags';
import { Promo } from './containers/Promo';
import AuthenticatedRoute from './components/routing/AuthenticatedRoute';
import UnauthenticatedRoute from './components/routing/UnauthenticatedRoute';
import Rnrs from './containers/Rnrs';
import VendorContainer from './containers/Vendor';
import FareharborItems from './containers/FareharborItems';
import StripeAccounts from './containers/StripeAccounts';
import Cities from './containers/Cities';
import ItineraryTemplatePage from './containers/Cities/components/ItineraryTemplatePage';
import ItineraryTemplateEditPage from './containers/Cities/components/ItineraryTemplateEditPage';
import ItineraryTemplateCreatePage from './containers/Cities/components/ItineraryTemplateCreatePage';

export default ({ ...props }) => (
  <Switch>
    <AuthenticatedRoute
      exact
      path='/'
      component={Orders}
      props={props}
      pageLabel='home'
    />
    <AuthenticatedRoute
      exact
      path='/parties'
      component={Parties}
      props={props}
      pageLabel='partyListings'
    />
    <AuthenticatedRoute
      exact
      path='/party/:id?'
      component={Party}
      props={props}
      pageLabel='partyIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/users'
      component={Users}
      props={props}
      pageLabel='userListings'
    />
    <AuthenticatedRoute
      exact
      path='/users/:id?'
      component={User}
      props={props}
      pageLabel='userIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/party/:id?/event/:eventid?'
      component={Event}
      props={props}
      pageLabel='eventIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/activities/:id'
      component={ActivityPage}
      props={props}
      pageLabel='activityIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/activities/:city?/:tag?'
      component={Activities}
      props={props}
      pageLabel='activitiesListings'
    />
    <AuthenticatedRoute
      path='/activities/:id/options/:optionId/edit'
      component={ActivityPage}
      props={props}
      pageLabel='editBookingOption'
    />
    <AuthenticatedRoute
      exact
      path='/cities'
      component={Cities}
      props={props}
      pageLabel='cityGuideListings'
    />
    <AuthenticatedRoute
      exact
      path='/orders'
      component={Orders}
      props={props}
      pageLabel='ordersListings'
    />
    <AuthenticatedRoute
      exact
      path='/cities/explore/:city?'
      component={CityExplore}
      props={props}
      pageLabel='cityExploreActivities'
    />
    <AuthenticatedRoute
      exact
      path='/cities/:citySlug/itinerary-templates'
      component={ItineraryTemplatePage}
      props={props}
      pageLabel='itineraryTemplate'
    />
    <AuthenticatedRoute
      exact
      path='/cities/:citySlug/itinerary-templates/new'
      component={ItineraryTemplateCreatePage}
      props={props}
      pageLabel='itineraryTemplateCreate'
    />
    <AuthenticatedRoute
      exact
      path='/cities/:citySlug/itinerary-templates/:id'
      component={ItineraryTemplateEditPage}
      props={props}
      pageLabel='itineraryTemplateEdit'
    />
    <AuthenticatedRoute
      exact
      path='/exploreConfig'
      component={CityExplore}
      props={{ ...props, defaultCityName: '#default' }}
      pageLabel='exploreConfig'
    />
    <AuthenticatedRoute
      exact
      path='/cities/guide/:city?'
      component={CityGuide}
      props={props}
      pageLabel='cityGuideDetail'
    />
    <AuthenticatedRoute
      exact
      path='/entertainments'
      component={Entertainments}
      props={props}
      pageLabel='entertainmentListings'
    />
    <AuthenticatedRoute
      exact
      path='/orders/:id'
      component={OrderPage}
      props={props}
      pageLabel='orderIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/orders/:id/edit'
      component={OrderPage}
      props={props}
      pageLabel='orderIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/orders/:id/cancel'
      component={OrderPage}
      props={props}
      pageLabel='orderIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/orders/:id/refunds/request'
      component={OrderPage}
      props={props}
      pageLabel='orderIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/tags'
      component={Tags}
      props={props}
      pageLabel='tagsListings'
    />
    <AuthenticatedRoute
      exact
      path='/promo'
      component={Promo}
      props={{ ...props, timestamp: new Date().toString() }}
      pageLabel='promoListings'
    />
    <AuthenticatedRoute
      exact
      path='/vendors/:type/:id'
      component={VendorContainer}
      props={props}
      pageLabel='vendorsIndividualDetail'
    />
    <AuthenticatedRoute
      exact
      path='/rnrs'
      component={Rnrs}
      props={props}
      pageLabel='rnrsListings'
    />
    <AuthenticatedRoute
      exact
      path='/fareharbor'
      component={FareharborItems}
      props={props}
      pageLabel='fareHarborListings'
    />
    <AuthenticatedRoute
      exact
      path='/stripe-accounts'
      component={StripeAccounts}
      props={props}
      pageLabel='stripeAcoountsListings'
    />
    <UnauthenticatedRoute
      exact
      path='/login'
      component={Login}
      props={props}
      pageLabel='login'
    />
    <Route component={NotFound} pageLabel='NotFound' />
  </Switch>
);
